export default __webpack_public_path__ + "static/media/illustrationComputer.c4fc75b0.png";